// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-header-title[data-v-d9c26e82] {\n  padding: 0.25rem 0.25rem 0.25rem 0.5rem !important;\n}", ""]);
// Exports
module.exports = exports;
